<script>
import GroupedBarChart from '@/components/plots/GroupedBarChart'

import {stacked_bars} from '@/components/plots/atoms'
import {DomainTypes} from '@/components/plots/enums'

export default {
  computed: {
    bars() {
      return stacked_bars(
        this.x, this.y, this.band_scale, this.cont_scale, this.orientation)
    },
    domain_type() {
      return DomainTypes.RowSum
    }
  },
  extends: GroupedBarChart,
  name: 'candela-stacked-bar-chart'
}
</script>
